/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Create_Project_References_DescriptionInputs */



/**
* | output |
* | --- |
* | "Choose what this project can draw on — knowledge spaces to answer from, datasets to query, and tool connections the assistant may use here." |
*
* @param {Create_Project_References_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const create_project_references_description = /** @type {((inputs?: Create_Project_References_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Create_Project_References_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wählen Sie, worauf dieses Projekt zugreifen darf — Wissens-Spaces als Antwortquelle, Datensätze für Abfragen und Tool-Verbindungen, die der Assistent hier nutzen darf.")
	return /** @type {LocalizedString} */ ("Choose what this project can draw on — knowledge spaces to answer from, datasets to query, and tool connections the assistant may use here.")
});